export const GET_LOCATIONS = 'GET_LOCATIONS';
export const ADD_LOCATION = 'ADD_LOCATION';
export const DELETE_LOCATION = 'DELETE_LOCATION';
export const EDIT_LOCATION = 'EDIT_LOCATION';
